import Vue from 'vue'

export const getAllFeatureFlags = async (idToken) => {
  const response = await Vue.axios.get('/feature_flags', { headers: { Authorization: `Bearer ${idToken}` } })
  return response.data
}

export const updateFeatureFlag = async (idToken, selectedFeatureFlag) => {
  const data = {
    id: selectedFeatureFlag.id,
    is_enabled: selectedFeatureFlag.is_enabled
  }
  const response = await Vue.axios.patch(`/feature_flags/${selectedFeatureFlag.id}`, data, { headers: { Authorization: `Bearer ${idToken}` } })
  return response.data
}



// WEBPACK FOOTER //
// ./src/apiServices/featureFlagService.js